import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
@Injectable()
export class SettingsService {

  constructor() { }


getAttendanceSettings()
{
  return firebase.database().ref("settings").child("attendance");
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/settings/settings.service.ts